<template>
  <el-dialog
    title="My Bids"
    :visible.sync="isOpen"
    width="50%"
    append-to-body
    :close-on-click-modal="false"
    destroy-on-close
    :footer="null"
  >
    <el-table
        class="common-table"
        :data="tableList"
        v-loading="loading"
        highlight-current-row
      >
        <el-table-column prop="data1" label="Serial number">
          <template slot-scope="{ $index }">
            {{ tableList.length - $index }}
          </template>
        </el-table-column>
        <el-table-column prop="data2" label="Time">
          <template slot-scope="{ row }">
            {{moment(row.timestamp).format("YYYY-MM-DD HH:mm:ss")}}
          </template>
        </el-table-column>
        <el-table-column prop="data3" label="Bid price" align="right">
          <template slot-scope="{ row }">
            <big-number :number="row.amount"/><span class="td-word-sm">TCash</span>
          </template>
        </el-table-column>
      </el-table>
  </el-dialog>
</template>

<script>
import { auctionDetailList } from "@/api/auction.js"
export default {
  data() {
    return {
      loading:false,
      isOpen: false,
      number:undefined,
      tableList: []
    };
  },
  computed: {},
  methods: {
    open({number}) {
      this.isOpen = true;
      this.number = number;
      this.getList();
    },
    close() {
      this.isOpen = false;
    },
    getList() {
      this.loading = true;
      auctionDetailList({
        pageSize:1000,
        page:1,
        number:this.number,
        account:this.$store.getters.metaMaskObj.account
      }).then(res => {
        this.tableList = res.data ? res.data.data : [];
        this.loading = false;
      }).catch(e => {
        this.loading = false;
      })
    },
  },
  created() {}
};
</script>
<style scoped lang="scss">
.common-table {
  >>> .el-loading-mask {
    background-color: rgba(255, 255, 255, .6);
  }

  >>> .el-loading-spinner .path {
    stroke: #2675f1;
  }

  >>> &.el-table td {
    color: inherit;
  }
}
</style>
